import { isEmpty } from 'ramda'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import { apiStateSelectors } from '../../../../modules/api/apiState'
import { userApiEvents } from '../../../../modules/api/user'
import { uiEvents } from '../../../../modules/ui/state'
import { NoContent } from '../../../components'
import styles from './VerifyEmail.module.scss'

type VerifyEmailParams = {
  userId: string
  verifyId: string
}

type VerifyEmailProps = RouteComponentProps<VerifyEmailParams>

const VerifyEmail = ({ match }: VerifyEmailProps): JSX.Element => {
  const dispatch = useDispatch()
  const { userId, verifyId } = match.params

  const generalErrors = useSelector(state =>
    apiStateSelectors.getGeneralFormErrorsByEvent(state)(userApiEvents.verifyEmail_request({ id: userId, verifyId })),
  )

  const verifyEmail = useCallback(() => {
    userId && verifyId && dispatch(userApiEvents.verifyEmail_request({ id: userId, verifyId }))
  }, [userId, verifyId, dispatch])

  useEffect(() => {
    if (!isEmpty(generalErrors)) {
      dispatch(uiEvents.redirect(`/login?error=${generalErrors[0]}`))
    }
  }, [generalErrors, dispatch])

  useEffectOnce(() => {
    verifyEmail()
  })

  return (
    <div className={styles.root}>
      <NoContent
        heading="Verifying your email address..."
        subHeading={
          <>
            You will be redirected shortly!{' '}
            <button
              onClick={e => {
                e.preventDefault()
                dispatch(
                  uiEvents.redirect(
                    '/login?error=Email Verification failed. Please login and re-send email verification from your profile.',
                  ),
                )
              }}
            >
              Click here if nothing happens.
            </button>
          </>
        }
      />
    </div>
  )
}

export default VerifyEmail
